import React from 'react';
import ListLayout from 'components/ListLayout';
import { InformationSalesReportWrapper } from './InformationSalesReport.style';
import CardInformationSalesReport from './CardInformationSalesReport';
import { format, parseISO } from 'date-fns';
import { formatDateMonthYear } from 'utils';
import TableSalesReport from '../../InvoicesMerchantTable/TableSalesReport';

interface Iprops {
  onData: any;
}

const InformationSalesReport = ({ onData }: Iprops) => {
  const startPeriod = format(parseISO(onData?.startDate), 'dd/MM/yyyy');
  const endPeriod = format(parseISO(onData?.endDate), 'dd/MM/yyyy');

  return (
    <ListLayout>
      <InformationSalesReportWrapper>
        {onData && (
          <>
            <CardInformationSalesReport
              invoiceNumber={onData.subscriptionId}
              invoiceDate={
                onData.createdAt
                  ? `${format(new Date(onData.createdAt), formatDateMonthYear)}`
                  : ''
              }
              mainName={onData?.merchant.name}
              address={onData?.merchant.billingAddress}
              vatNumber={onData?.merchantTaxNumber}
              typeOfInvoice={`Formule STANDARD Achil`}
              description={`Facture pour l'abonnement Achil du`}
              startAt={startPeriod}
              endAt={endPeriod}
              dateOfBankDebit={''}
              bankAccount={onData.bankAccount}
            />
            <TableSalesReport onDataTable={onData} />
          </>
        )}
      </InformationSalesReportWrapper>
    </ListLayout>
  );
};

export default InformationSalesReport;
